export const names = ['Fajr', 'Zuhr', 'Asr', 'Maghrib', 'Isha'];